import { ICreateUserDto } from "@/lib/interfaces/User/createUserInterface";
import { UserEntity } from "@/models/userEntity";
import { Api } from "@/services/mrfiktiv/api";
import { IUserRoleUpdateDto } from "@/store/interface/user.role.dto.interface";
import Vue from "vue";
import { IUserPermissionUpdateDto } from "../../../store/interface/user.permission.dto.interface";
import { UpdateUserDto } from "../v1/mrfiktiv.api";
class UserService {
  ROUTE = "/user";

  async get(id: string): Promise<UserEntity> {
    const api = new Api().instance();

    let User: UserEntity;

    try {
      const response = await api.get(`${this.ROUTE}/${id}`);
      User = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);

      throw error;
    }

    return User;
  }

  async getAll(): Promise<UserEntity[]> {
    const api = new Api().instance();

    let User: UserEntity[];

    try {
      const response = await api.get(`${this.ROUTE}/all`);
      User = response.data as UserEntity[];
    } catch (error) {
      Vue.$log.error(error);

      throw error;
    }

    return User;
  }

  async getByAuthInfo(): Promise<UserEntity> {
    const api = new Api().instance();

    let User: UserEntity;

    try {
      const response = await api.get(`${this.ROUTE}`);
      User = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);

      throw error;
    }

    return User;
  }

  async update(id: string, updateUser: UpdateUserDto): Promise<UserEntity> {
    const api = new Api().instance();
    let updatedUser: UserEntity;

    try {
      const response = await api.patch(`${this.ROUTE}/${id}`, updateUser);
      updatedUser = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);
      throw error;
    }

    return updatedUser;
  }

  async removePermission(updatePermission: IUserPermissionUpdateDto): Promise<UserEntity> {
    const api = new Api().instance();
    let updatedUser: UserEntity;

    const dto = {
      permission: updatePermission.permissions
    };

    try {
      const response = await api.patch(`${this.ROUTE}/${updatePermission.id}/permission/remove`, dto);
      updatedUser = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);
      throw error;
    }

    return updatedUser;
  }

  async addPermissions(user: UserEntity): Promise<UserEntity> {
    const api = new Api().instance();
    let updatedUser: UserEntity;

    const dto = {
      permission: user.permission
    };

    try {
      const response = await api.patch(`${this.ROUTE}/${user._id}/permission/add`, dto);
      updatedUser = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);
      throw error;
    }

    return updatedUser;
  }

  async updateRole(userRole: IUserRoleUpdateDto): Promise<UserEntity> {
    const api = new Api().instance();
    let updatedUser: UserEntity;

    const dto = {
      roles: userRole.role
    };

    try {
      const response = await api.patch(`${this.ROUTE}/${userRole.id}/role`, dto);
      updatedUser = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);
      throw error;
    }

    return updatedUser;
  }

  async invite(createUser: ICreateUserDto): Promise<UserEntity> {
    const api = new Api().instance();
    let invitedUser: UserEntity;
    try {
      const response = await api.post(`${this.ROUTE}/invite/asAdmin`, createUser);
      invitedUser = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);
      throw error;
    }

    return invitedUser;
  }

  async create(createUser: UserEntity): Promise<UserEntity> {
    const api = new Api().instance();

    try {
      const response = await api.post(`${this.ROUTE}`, createUser);
      createUser = response.data as UserEntity;
    } catch (error) {
      Vue.$log.error(error);
      throw error;
    }

    return createUser;
  }
}

export default new UserService();
